export const customContext = typeof window !== 'undefined'
  && typeof window?.__EXPERIENCE_CONTEXT__?.customContext !== 'undefined'
  ? window.__EXPERIENCE_CONTEXT__.customContext
  : {};